import React from 'react';
import PropTypes from 'prop-types';
import { FeatureAvailableIcon } from '../FeatureAvailableIcon';

export const BoolFeature = ({ slug, trimLevel }) => (
  <FeatureAvailableIcon available={trimLevel[slug]}/>
); 

BoolFeature.propTypes={
  trimLevel: PropTypes.object.isRequired,
  slug:PropTypes.string.isRequired,
};


